import React from 'react';
import ReactDOM from 'react-dom';

import 'services/i18n';
import * as serviceWorker from './serviceWorker';
import App from './App';

import 'antd/dist/antd.css';
import 'moment/locale/uk';
import 'moment/locale/ru';
import 'moment/locale/en-gb';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
